import { useRef, useState } from "react";

const clamp = (v) => Math.min(100, Math.max(0, Math.round(v)));

// Pointer-drag handler that moves an image focal point (x/y %) like grabbing the photo.
export default function useDragFocus({ x, y, onChange, enabled = true, sensitivity = 1.4 }) {
  const start = useRef(null);
  const [dragging, setDragging] = useState(false);

  if (!enabled) return { dragging: false, handlers: {} };

  const handlers = {
    onPointerDown: (e) => {
      if (e.button !== undefined && e.button !== 0) return;
      e.preventDefault();
      e.currentTarget.setPointerCapture?.(e.pointerId);
      const r = e.currentTarget.getBoundingClientRect();
      start.current = { px: e.clientX, py: e.clientY, x, y, w: r.width || 1, h: r.height || 1 };
      setDragging(true);
    },
    onPointerMove: (e) => {
      const s = start.current;
      if (!s) return;
      const nx = clamp(s.x - ((e.clientX - s.px) / s.w) * 100 * sensitivity);
      const ny = clamp(s.y - ((e.clientY - s.py) / s.h) * 100 * sensitivity);
      if (nx !== x || ny !== y) onChange(nx, ny);
    },
    onPointerUp: (e) => {
      start.current = null;
      e.currentTarget.releasePointerCapture?.(e.pointerId);
      setDragging(false);
    },
    onPointerCancel: () => {
      start.current = null;
      setDragging(false);
    },
    style: { touchAction: "none", cursor: dragging ? "grabbing" : "grab" },
  };
  return { dragging, handlers };
}
